import { contentMessages } from './messages';
import { ContentData, ResourceDay } from './types';

const enBreatheBubbleContent: ContentData = {
	title: contentMessages.day2Title,
	content: [
		{
			contentTitle: contentMessages.day2Title,
			thumbnail: '/_n/images/schools/guides/breathe-bubble-thumbnail.webp',
			contentUrl: 'https://assets.calm.com/8c4dfff06e7927e1b2d0d172751e54dd.mp4',
			type: 'video',
			loop: true,
		},
	],
};

const deBreatheBubbleContent: ContentData = {
	title: contentMessages.day2Title,
	content: [
		{
			contentTitle: contentMessages.day2Title,
			thumbnail: '/_n/images/schools/guides/localized-breathe-bubble-thumbnail.webp',
			contentUrl: 'https://assets.calm.com/7dc197d34bc109a8149032d882a63821.mp4',
			type: 'video',
			loop: true,
		},
	],
};

const frBreatheBubbleContent: ContentData = {
	title: contentMessages.day2Title,
	content: [
		{
			contentTitle: contentMessages.day2Title,
			thumbnail: '/_n/images/schools/guides/localized-breathe-bubble-thumbnail.webp',
			contentUrl: 'https://assets.calm.com/0e7e6b1552d2b5f774348b4cf597a564.mp4',
			type: 'video',
			loop: true,
		},
	],
};

const esBreatheBubbleContent: ContentData = {
	title: contentMessages.day2Title,
	content: [
		{
			contentTitle: contentMessages.day2Title,
			thumbnail: '/_n/images/schools/guides/localized-breathe-bubble-thumbnail.webp',
			contentUrl: 'https://assets.calm.com/d2d1a48c79b888d374c5f7544a4c5fb2.mp4',
			type: 'video',
			loop: true,
		},
	],
};

const ptBreatheBubbleContent: ContentData = {
	title: contentMessages.day2Title,
	content: [
		{
			contentTitle: contentMessages.day2Title,
			thumbnail: '/_n/images/schools/guides/localized-breathe-bubble-thumbnail.webp',
			contentUrl: 'https://assets.calm.com/7dc197d34bc109a8149032d882a63821.mp4',
			type: 'video',
			loop: true,
		},
	],
};

export const teacherContent: ResourceDay[] = [
	{
		en: {
			title: contentMessages.day1Title,
			content: [
				{
					contentTitle: contentMessages.day1ContentTitle,
					contentAuthor: contentMessages.day1ContentAuthor,
					thumbnail: '/_n/images/schools/guides/b7e2463af317de1194ba48e9566bd8db.webp',
					contentUrl: 'https://assets.calm.com/53e7bc6ed0ae6d47a574095de445c4bc.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: enBreatheBubbleContent,
		de: deBreatheBubbleContent,
		fr: frBreatheBubbleContent,
		pt: ptBreatheBubbleContent,
		es: esBreatheBubbleContent,
	},
	{
		en: {
			title: contentMessages.day3Title,
			content: [
				{
					contentTitle: contentMessages.day3ContentTitle,
					contentAuthor: contentMessages.day3ContentAuthor,
					thumbnail: '/_n/images/schools/guides/ca25d62a5fa57c7f519061b739925c37.webp',
					contentUrl: 'https://assets.calm.com/c9844340f6a75f0a9c46367483d75954.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day4Title,
			content: [
				{
					contentTitle: contentMessages.day4ContentTitle,
					contentAuthor: contentMessages.day4ContentAuthor,
					thumbnail: '/_n/images/schools/guides/adfa764b85a596a6381db6349c17d260.webp',
					contentUrl: 'https://assets.calm.com/6b9bfdbd9daad130bf97c1ce3fcad8d9.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day5Title,
			content: [],
		},
	},
	{
		es: {
			title: contentMessages.day6Title,
			content: [
				{
					contentTitle: contentMessages.day6ContentTitle,
					contentAuthor: contentMessages.day6ContentAuthor,
					thumbnail: '/_n/images/schools/guides/cf5e9053c8342cb08187ae19897271e7.webp',
					contentUrl: 'https://assets.calm.com/1aa2b894a3a838b408ed141e6c942fe5.m4a',
					type: 'audio',
				},
			],
		},
		de: {
			title: contentMessages.day6Title,
			content: [
				{
					contentTitle: contentMessages.day6ContentTitle,
					contentAuthor: contentMessages.day6ContentAuthor,
					thumbnail: '/_n/images/schools/guides/cf5e9053c8342cb08187ae19897271e7.webp',
					contentUrl: 'https://assets.calm.com/90935000ed8d6c07cef43ef0491e0eb7.m4a',
					type: 'audio',
				},
			],
		},
		fr: {
			title: contentMessages.day6Title,
			content: [
				{
					contentTitle: contentMessages.day6ContentTitle,
					contentAuthor: contentMessages.day6ContentAuthor,
					thumbnail: '/_n/images/schools/guides/cf5e9053c8342cb08187ae19897271e7.webp',
					contentUrl: 'https://assets.calm.com/91c32daefc62e1ab7238927a962ae27f.m4a',
					type: 'audio',
				},
			],
		},
		en: {
			title: contentMessages.day6Title,
			content: [
				{
					contentTitle: contentMessages.day6ContentTitle,
					contentAuthor: contentMessages.day6ContentAuthor,
					thumbnail: '/_n/images/schools/guides/cf5e9053c8342cb08187ae19897271e7.webp',
					contentUrl: 'https://assets.calm.com/3d6519e323712843ce465e9f1a9ae2dd.m4a',
					type: 'audio',
				},
			],
		},
		pt: {
			title: contentMessages.day6Title,
			content: [
				{
					contentTitle: contentMessages.day6ContentTitle,
					contentAuthor: contentMessages.day6ContentAuthor,
					thumbnail: '/_n/images/schools/guides/cf5e9053c8342cb08187ae19897271e7.webp',
					contentUrl: 'https://assets.calm.com/57cd52ba4ab9584e555d9556f532e4d4.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		isEnglishOnly: true,
		en: {
			title: contentMessages.day7Title,
			content: [
				{
					contentTitle: contentMessages.day7ContentTitle,
					contentAuthor: contentMessages.day7ContentAuthor,
					thumbnail: '/_n/images/schools/guides/b4220fe1dca921701404f768a0b0ee11.webp',
					contentUrl: 'https://assets.calm.com/2df9e1ef76b0ff1b881fa24343503691.m4a',
					type: 'audio',
				},
				{
					contentTitle: contentMessages.day7ContentTitle2,
					contentAuthor: contentMessages.day7ContentAuthor,
					contentUrl: 'https://assets.calm.com/f5ec5af76d1a28aa0c3a88380c8f0e06.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day8Title,
			content: [
				{
					contentTitle: contentMessages.day8ContentTitle,
					contentAuthor: contentMessages.day8ContentAuthor,
					thumbnail: '/_n/images/schools/guides/867c2e9450958af899a709bcaae08810.webp',
					contentUrl: 'https://assets.calm.com/8856429bdc06e7bbae4ea73769fdadc9.m4a',
					type: 'audio',
				},
			],
		},
		pt: {
			title: contentMessages.day8Title,
			content: [
				{
					contentTitle: contentMessages.day8ContentTitle,
					contentAuthor: contentMessages.day8ContentAuthor,
					thumbnail: '/_n/images/schools/guides/867c2e9450958af899a709bcaae08810.webp',
					contentUrl: 'https://assets.calm.com/c140f0a22c1f9161592a9ea9fecefd32.m4a',
					type: 'audio',
				},
			],
		},
		fr: {
			title: contentMessages.day8Title,
			content: [
				{
					contentTitle: contentMessages.day8ContentTitle,
					contentAuthor: contentMessages.day8ContentAuthor,
					thumbnail: '/_n/images/schools/guides/867c2e9450958af899a709bcaae08810.webp',
					contentUrl: 'https://assets.calm.com/47295ef46089d1b555e2d76c3645522e.m4a',
					type: 'audio',
				},
			],
		},
		es: {
			title: contentMessages.day8Title,
			content: [
				{
					contentTitle: contentMessages.day8ContentTitle,
					contentAuthor: contentMessages.day8ContentAuthor,
					thumbnail: '/_n/images/schools/guides/867c2e9450958af899a709bcaae08810.webp',
					contentUrl: 'https://assets.calm.com/c140f0a22c1f9161592a9ea9fecefd32.m4a',
					type: 'audio',
				},
			],
		},
		de: {
			title: contentMessages.day8Title,
			content: [
				{
					contentTitle: contentMessages.day8ContentTitle,
					contentAuthor: contentMessages.day8ContentAuthor,
					thumbnail: '/_n/images/schools/guides/867c2e9450958af899a709bcaae08810.webp',
					contentUrl: 'https://assets.calm.com/ecab93ab95fd29383f4fdb6e5bca24f8.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		isEnglishOnly: true,
		en: {
			title: contentMessages.day9Title,
			content: [
				{
					contentTitle: contentMessages.day9Title,
					contentAuthor: contentMessages.day9ContentAuthor,
					thumbnail: '/_n/images/schools/guides/1c8a3bcca68c1f1b424110005f8fe6cf.webp',
					contentUrl:
						'https://assets-videos.calm.com/hls/729c4d96a1d3ca1175ff9d778d7159e7/download/729c4d96a1d3ca1175ff9d778d7159e7.mp4',
					type: 'video',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day10Title,
			content: [
				{
					contentTitle: contentMessages.day10ContentTitle,
					contentAuthor: contentMessages.day10ContentAuthor,
					thumbnail: '/_n/images/schools/guides/c9a0c962547955541a3e028fe2c77a9f.webp',
					contentUrl: 'https://assets.calm.com/2e9f98070feebca274ebf2963889292f.m4a',
					type: 'audio',
				},
			],
		},
		fr: {
			title: contentMessages.day10Title,
			content: [
				{
					contentTitle: contentMessages.day10ContentTitle,
					contentAuthor: contentMessages.day10ContentAuthor,
					thumbnail: '/_n/images/schools/guides/c9a0c962547955541a3e028fe2c77a9f.webp',
					contentUrl: 'https://assets.calm.com/207d54245666b267864e5e8eec6fe988.m4a',
					type: 'audio',
				},
			],
		},
		pt: {
			title: contentMessages.day10Title,
			content: [
				{
					contentTitle: contentMessages.day10ContentTitle,
					contentAuthor: contentMessages.day10ContentAuthor,
					thumbnail: '/_n/images/schools/guides/c9a0c962547955541a3e028fe2c77a9f.webp',
					contentUrl: 'https://assets.calm.com/af9683903c0ef240e48f1bf25ee9670d.m4a',
					type: 'audio',
				},
			],
		},
		es: {
			title: contentMessages.day10Title,
			content: [
				{
					contentTitle: contentMessages.day10ContentTitle,
					contentAuthor: contentMessages.day10ContentAuthor,
					thumbnail: '/_n/images/schools/guides/c9a0c962547955541a3e028fe2c77a9f.webp',
					contentUrl: 'https://assets.calm.com/263ceebdcdd5e4f6970148515452b7e3.m4a',
					type: 'audio',
				},
			],
		},
		de: {
			title: contentMessages.day10Title,
			content: [
				{
					contentTitle: contentMessages.day10ContentTitle,
					contentAuthor: contentMessages.day10ContentAuthor,
					thumbnail: '/_n/images/schools/guides/c9a0c962547955541a3e028fe2c77a9f.webp',
					contentUrl: 'https://assets.calm.com/bcb7ad27e1c57cc97279020229cc3fd5.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day11Title,
			content: [
				{
					contentTitle: contentMessages.day11ContentTitle,
					contentAuthor: contentMessages.day11ContentAuthor,
					thumbnail: '/_n/images/schools/guides/a593f6c4e836562ecae7c5ece5e82841.webp',
					contentUrl: 'https://assets.calm.com/aa42a2e33cdb2b08a76e009f95f9ba38.m4a',
					type: 'audio',
				},
			],
		},
		es: {
			title: contentMessages.day11Title,
			content: [
				{
					contentTitle: contentMessages.day11ContentTitle,
					contentAuthor: contentMessages.day11ContentAuthor,
					thumbnail: '/_n/images/schools/guides/a593f6c4e836562ecae7c5ece5e82841.webp',
					contentUrl: 'https://assets.calm.com/e201135caf565f33e2611578af05ae43.m4a',
					type: 'audio',
				},
			],
		},
		de: {
			title: contentMessages.day11Title,
			content: [
				{
					contentTitle: contentMessages.day11ContentTitle,
					contentAuthor: contentMessages.day11ContentAuthor,
					thumbnail: '/_n/images/schools/guides/a593f6c4e836562ecae7c5ece5e82841.webp',
					contentUrl: 'https://assets.calm.com/11fe8a38c182c99035c59bcfe9f4a1ad.m4a',
					type: 'audio',
				},
			],
		},
		pt: {
			title: contentMessages.day11Title,
			content: [
				{
					contentTitle: contentMessages.day11ContentTitle,
					contentAuthor: contentMessages.day11ContentAuthor,
					thumbnail: '/_n/images/schools/guides/a593f6c4e836562ecae7c5ece5e82841.webp',
					contentUrl: 'https://assets.calm.com/4d47b64367d05535bfa7c8e3fd86be1b.m4a',
					type: 'audio',
				},
			],
		},
		fr: {
			title: contentMessages.day11Title,
			content: [
				{
					contentTitle: contentMessages.day11ContentTitle,
					contentAuthor: contentMessages.day11ContentAuthor,
					thumbnail: '/_n/images/schools/guides/a593f6c4e836562ecae7c5ece5e82841.webp',
					contentUrl: 'https://assets.calm.com/2be6ef43b6f61d720404807ea8860622.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day12Title,
			isMultiple: true,
			content: [
				{
					contentTitle: contentMessages.day12ContentTitle,
					thumbnail: '/_n/images/schools/guides/867b08dfa1906c423bb8c347e30f4af3.webp',
					contentUrl: 'https://assets.calm.com/6e7fcb76ca5174cc3b3c6906e4f963f2.m4a',
					type: 'audio',
				},
				{
					contentTitle: contentMessages.day12ContentTitle2,
					thumbnail: '/_n/images/schools/guides/03e8f1a136c5e7192c8939f9e103c7c2.webp',
					contentUrl: 'https://assets.calm.com/4ffcdb0c7bdd54a4ba9146f006e58320.m4a',
					type: 'audio',
				},
				{
					contentTitle: contentMessages.day12ContentTitle3,
					thumbnail: '/_n/images/schools/guides/3889cfd72c0ef8cbd64c1e33fa8cbeb4.webp',
					contentUrl: 'https://assets.calm.com/8bf6e288aeb1f7141aaf91ca365d5e6e.m4a',
					type: 'audio',
				},
				{
					contentTitle: contentMessages.day12ContentTitle4,
					thumbnail: '/_n/images/schools/guides/88f315f79fa2ce0ca5b38c38b5810c58.webp',
					contentUrl: 'https://assets.calm.com/b057912a7e714fbeef2f26c2f1846966.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day13Title,
			content: [
				{
					contentTitle: contentMessages.day13ContentTitle,
					contentAuthor: contentMessages.day13ContentAuthor,
					thumbnail: '/_n/images/schools/guides/ea709425b606771c2cd5ac873b174afa.webp',
					contentUrl: 'https://assets.calm.com/ea952a47eb52456234e3a16d51023923.m4a',
					type: 'audio',
				},
			],
		},
		fr: {
			title: contentMessages.day13Title,
			content: [
				{
					contentTitle: contentMessages.day13ContentTitle,
					contentAuthor: contentMessages.day13ContentAuthor,
					thumbnail: '/_n/images/schools/guides/ea709425b606771c2cd5ac873b174afa.webp',
					contentUrl: 'https://assets.calm.com/5e39ef69e0c42fdbc38c93675b20a133.m4a',
					type: 'audio',
				},
			],
		},
		de: {
			title: contentMessages.day13Title,
			content: [
				{
					contentTitle: contentMessages.day13ContentTitle,
					contentAuthor: contentMessages.day13ContentAuthor,
					thumbnail: '/_n/images/schools/guides/ea709425b606771c2cd5ac873b174afa.webp',
					contentUrl: 'https://assets.calm.com/3a3cacc90a6b82ac0ba523837aa096ae.m4a',
					type: 'audio',
				},
			],
		},
		es: {
			title: contentMessages.day13Title,
			content: [
				{
					contentTitle: contentMessages.day13ContentTitle,
					contentAuthor: contentMessages.day13ContentAuthor,
					thumbnail: '/_n/images/schools/guides/ea709425b606771c2cd5ac873b174afa.webp',
					contentUrl: 'https://assets.calm.com/4049765cc54ae0b1a518faba34b95149.m4a',
					type: 'audio',
				},
			],
		},
		pt: {
			title: contentMessages.day13Title,
			content: [
				{
					contentTitle: contentMessages.day13ContentTitle,
					contentAuthor: contentMessages.day13ContentAuthor,
					thumbnail: '/_n/images/schools/guides/ea709425b606771c2cd5ac873b174afa.webp',
					contentUrl: 'https://assets.calm.com/c27651a344e85448ad52d4a5d4a6836e.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day14Title,
			content: [
				{
					contentTitle: contentMessages.day14Title,
					contentAuthor: contentMessages.day14ContentAuthor,
					thumbnail: '/_n/images/schools/guides/539ca85997017e5fe827b31f3a250e9b.webp',
					contentUrl: 'https://assets.calm.com/350d2b2ae5fa19fd2d09dc4ef212be5d.m4a',
					type: 'audio',
				},
			],
		},
		es: {
			title: contentMessages.day14Title,
			content: [
				{
					contentTitle: contentMessages.day14Title,
					contentAuthor: contentMessages.day14ContentAuthor,
					thumbnail: '/_n/images/schools/guides/539ca85997017e5fe827b31f3a250e9b.webp',
					contentUrl: 'https://assets.calm.com/6251b5e96e9570e30ee55848a8e219f7.m4a',
					type: 'audio',
				},
			],
		},
		pt: {
			title: contentMessages.day14Title,
			content: [
				{
					contentTitle: contentMessages.day14Title,
					contentAuthor: contentMessages.day14ContentAuthor,
					thumbnail: '/_n/images/schools/guides/539ca85997017e5fe827b31f3a250e9b.webp',
					contentUrl: 'https://assets.calm.com/008e30fa75e0e8ba97e71a63b76d4b23.m4a',
					type: 'audio',
				},
			],
		},
		fr: {
			title: contentMessages.day14Title,
			content: [
				{
					contentTitle: contentMessages.day14Title,
					contentAuthor: contentMessages.day14ContentAuthor,
					thumbnail: '/_n/images/schools/guides/539ca85997017e5fe827b31f3a250e9b.webp',
					contentUrl: 'https://assets.calm.com/2e241008483d92b92fb092340768cc61.m4a',
					type: 'audio',
				},
			],
		},
		de: {
			title: contentMessages.day14Title,
			content: [
				{
					contentTitle: contentMessages.day14Title,
					contentAuthor: contentMessages.day14ContentAuthor,
					thumbnail: '/_n/images/schools/guides/539ca85997017e5fe827b31f3a250e9b.webp',
					contentUrl: 'https://assets.calm.com/7d1a77b49abff1256bce4102946267b0.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day15Title,
			content: [
				{
					contentTitle: contentMessages.day15ContentTitle,
					contentAuthor: contentMessages.day15ContentAuthor,
					thumbnail: '/_n/images/schools/guides/b546a0600182216fd9d471da57c2c8e5.webp',
					contentUrl: 'https://assets.calm.com/55395935b6c606b3a29636e673cdb4e5.m4a',
					type: 'audio',
				},
			],
		},
		de: {
			title: contentMessages.day15Title,
			content: [
				{
					contentTitle: contentMessages.day15ContentTitle,
					contentAuthor: contentMessages.day15ContentAuthor,
					thumbnail: '/_n/images/schools/guides/b546a0600182216fd9d471da57c2c8e5.webp',
					contentUrl: 'https://assets.calm.com/ab997d5698e91c20838add63702a7e80.m4a',
					type: 'audio',
				},
			],
		},
		es: {
			title: contentMessages.day15Title,
			content: [
				{
					contentTitle: contentMessages.day15ContentTitle,
					contentAuthor: contentMessages.day15ContentAuthor,
					thumbnail: '/_n/images/schools/guides/b546a0600182216fd9d471da57c2c8e5.webp',
					contentUrl: 'https://assets.calm.com/9ff005980cbda562037611b6a6c16926.m4a',
					type: 'audio',
				},
			],
		},
		fr: {
			title: contentMessages.day15Title,
			content: [
				{
					contentTitle: contentMessages.day15ContentTitle,
					contentAuthor: contentMessages.day15ContentAuthor,
					thumbnail: '/_n/images/schools/guides/b546a0600182216fd9d471da57c2c8e5.webp',
					contentUrl: 'https://assets.calm.com/7a6c4fbb89a0d53812e1b23db324217b.m4a',
					type: 'audio',
				},
			],
		},
		pt: {
			title: contentMessages.day15Title,
			content: [
				{
					contentTitle: contentMessages.day15ContentTitle,
					contentAuthor: contentMessages.day15ContentAuthor,
					thumbnail: '/_n/images/schools/guides/b546a0600182216fd9d471da57c2c8e5.webp',
					contentUrl: 'https://assets.calm.com/a46de22a850f79699cb42c1870f33d40.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day16Title,
			content: [
				{
					contentTitle: contentMessages.day16ContentTitle,
					contentAuthor: contentMessages.day16ContentAuthor,
					thumbnail: '/_n/images/schools/guides/45b4fcc021850234c5023bf5f448944a.webp',
					contentUrl: 'https://assets.calm.com/1fbe2b8f6df840715f270bc6f7e01bb3.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day17Title,
			content: [
				{
					contentTitle: contentMessages.day17ContentTitle,
					contentAuthor: contentMessages.day17ContentAuthor,
					thumbnail: '/_n/images/schools/guides/852505c60d542a3cd13aa93056102238.webp',
					contentUrl: 'https://assets.calm.com/bf6f65df5c974af60bfb7ae9b00bccd4.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		isEnglishOnly: true,
		en: {
			title: contentMessages.day18Title,
			content: [
				{
					contentTitle: contentMessages.day18Title,
					contentAuthor: contentMessages.day18ContentAuthor,
					thumbnail: '/_n/images/schools/guides/f10d5ea0dec431c1ddf14603793bea90.webp',
					contentUrl:
						'https://assets-videos.calm.com/hls/6c8cb83058bd5b55a3f9a1415bfbe496/download/6c8cb83058bd5b55a3f9a1415bfbe496.mp4',
					type: 'video',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day19Title,
			content: [
				{
					contentTitle: contentMessages.day19ContentTitle,
					contentAuthor: contentMessages.day19ContentAuthor,
					thumbnail: '/_n/images/schools/guides/414df93487fa7168728cb60b3e0c7f16.webp',
					contentUrl: 'https://assets.calm.com/e1d399d661e475554baf1cd77afaa8c3.m4a',
					type: 'audio',
				},
			],
		},
		de: deBreatheBubbleContent,
		fr: frBreatheBubbleContent,
		pt: ptBreatheBubbleContent,
		es: esBreatheBubbleContent,
	},
	{
		en: {
			title: contentMessages.day20Title,
			content: [
				{
					contentTitle: contentMessages.day20ContentTitle,
					thumbnail: '/_n/images/schools/guides/b9038c8088eeaecf73ad1041deaa33df.webp',
					contentUrl: 'https://assets.calm.com/a97484b7d7f2e060119291fb7cbae76e.mpga',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day21Title,
			content: [],
		},
	},
	{
		en: {
			title: contentMessages.day22Title,
			content: [
				{
					contentTitle: contentMessages.day22ContentTitle,
					contentAuthor: contentMessages.day22ContentAuthor,
					thumbnail: '/_n/images/schools/guides/ea709425b606771c2cd5ac873b174afa.webp',
					contentUrl: 'https://assets.calm.com/901cdb5bd3d95a9ffd692c4e93998674.m4a',
					type: 'audio',
				},
			],
		},
		fr: {
			title: contentMessages.day22Title,
			content: [
				{
					contentTitle: contentMessages.day22ContentTitle,
					contentAuthor: contentMessages.day22ContentAuthor,
					thumbnail: '/_n/images/schools/guides/ea709425b606771c2cd5ac873b174afa.webp',
					contentUrl: 'https://assets.calm.com/904aa4b5daf7be06967bdd2788dd3b86.m4a',
					type: 'audio',
				},
			],
		},
		es: {
			title: contentMessages.day22Title,
			content: [
				{
					contentTitle: contentMessages.day22ContentTitle,
					contentAuthor: contentMessages.day22ContentAuthor,
					thumbnail: '/_n/images/schools/guides/ea709425b606771c2cd5ac873b174afa.webp',
					contentUrl: 'https://assets.calm.com/f3d5d332f6cb05fe567134c4008d1a24.m4a',
					type: 'audio',
				},
			],
		},
		de: {
			title: contentMessages.day22Title,
			content: [
				{
					contentTitle: contentMessages.day22ContentTitle,
					contentAuthor: contentMessages.day22ContentAuthor,
					thumbnail: '/_n/images/schools/guides/ea709425b606771c2cd5ac873b174afa.webp',
					contentUrl: 'https://assets.calm.com/f29a9d08f37883f7b10f747ed2821a05.m4a',
					type: 'audio',
				},
			],
		},
		pt: {
			title: contentMessages.day22Title,
			content: [
				{
					contentTitle: contentMessages.day22ContentTitle,
					contentAuthor: contentMessages.day22ContentAuthor,
					thumbnail: '/_n/images/schools/guides/ea709425b606771c2cd5ac873b174afa.webp',
					contentUrl: 'https://assets.calm.com/a17946d199a93a4bf76e11405cfeabc1.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day23Title,
			content: [
				{
					contentTitle: contentMessages.day23ContentTitle,
					contentAuthor: contentMessages.day23ContentAuthor,
					thumbnail: '/_n/images/schools/guides/8ab281460472c0b6d35d721e816bd5e2.webp',
					contentUrl: 'https://assets.calm.com/d5c1dd187d925f21453dda1e301f4a69.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day24Title,
			content: [],
		},
	},
	{
		isEnglishOnly: true,
		en: {
			title: contentMessages.day25Title,
			content: [
				{
					contentTitle: contentMessages.day25ContentTitle,
					contentAuthor: contentMessages.day25ContentAuthor,
					thumbnail: '/_n/images/schools/guides/3e0d294b52b6ea246d179b97b3de7feb.webp',
					contentUrl: 'https://assets.calm.com/97b44aa108d1f28bece1bd6bdbce6beb.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day26Title,
			content: [],
		},
	},
	{
		en: {
			title: contentMessages.day27Title,
			content: [
				{
					contentTitle: contentMessages.day27Title,
					contentAuthor: contentMessages.day27ContentAuthor,
					thumbnail: '/_n/images/schools/guides/23eeb865a1d2889a988fa5e0aa6357a1.webp',
					contentUrl: 'https://assets.calm.com/3c5e291f45bf9cd59e0bcc9013f699f4.m4a',
					type: 'audio',
				},
			],
		},
		pt: {
			title: contentMessages.day27Title,
			content: [
				{
					contentTitle: contentMessages.day27Title,
					contentAuthor: contentMessages.day27ContentAuthor,
					thumbnail: '/_n/images/schools/guides/23eeb865a1d2889a988fa5e0aa6357a1.webp',
					contentUrl: 'https://assets.calm.com/9e6d5418ba6094be9e2a1470f983b86e.m4a',
					type: 'audio',
				},
			],
		},
		de: {
			title: contentMessages.day27Title,
			content: [
				{
					contentTitle: contentMessages.day27Title,
					contentAuthor: contentMessages.day27ContentAuthor,
					thumbnail: '/_n/images/schools/guides/23eeb865a1d2889a988fa5e0aa6357a1.webp',
					contentUrl: 'https://assets.calm.com/135e034a96c267a48ca56b34c0927592.m4a',
					type: 'audio',
				},
			],
		},
		es: {
			title: contentMessages.day27Title,
			content: [
				{
					contentTitle: contentMessages.day27Title,
					contentAuthor: contentMessages.day27ContentAuthor,
					thumbnail: '/_n/images/schools/guides/23eeb865a1d2889a988fa5e0aa6357a1.webp',
					contentUrl: 'https://assets.calm.com/c749f308a10bef058186e7db44570af1.m4a',
					type: 'audio',
				},
			],
		},
		fr: {
			title: contentMessages.day27Title,
			content: [
				{
					contentTitle: contentMessages.day27Title,
					contentAuthor: contentMessages.day27ContentAuthor,
					thumbnail: '/_n/images/schools/guides/23eeb865a1d2889a988fa5e0aa6357a1.webp',
					contentUrl: 'https://assets.calm.com/18e8f537b95c5f1fad9a73a3da5b4641.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day28Title,
			content: [
				{
					contentTitle: contentMessages.day28Title,
					thumbnail: '/_n/images/schools/guides/f9f0b2f51f2f6a40b8c9ae6ba987d154.webp',
					contentUrl: 'https://assets.calm.com/b7d5bb57b7c45178041bf2e4eecd8a9f.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		isEnglishOnly: true,
		en: {
			title: contentMessages.day29Title,
			content: [
				{
					contentTitle: contentMessages.day29ContentTitle,
					contentAuthor: contentMessages.day29ContentAuthor,
					thumbnail: '/_n/images/schools/guides/ec48f0cc520f0707a8902af86691bd49.webp',
					contentUrl: 'https://assets.calm.com/b5af7bfdcf71c384a0a6b5c35d49a912.m4a',
					type: 'audio',
				},
			],
		},
	},
	{
		en: {
			title: contentMessages.day30Title,
			content: [
				{
					contentTitle: contentMessages.day30ContentTitle,
					contentAuthor: contentMessages.day30ContentAuthor,
					thumbnail: '/_n/images/schools/guides/c16d6a6f0987241ee8a4fd809a7fd4be.webp',
					contentUrl: 'https://assets.calm.com/56743cb8cc163c7073a2d000125ca6ef.m4a',
					type: 'audio',
				},
			],
		},
	},
];
